import axios from 'axios';
import Vue from 'vue'

export default {

    getLogin () {
        return axios.get('/api/users/login/get')
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    
    ChangePassword(oldPassword,newPassword,confirmationPassword){
        return axios.post('/api/users/password/change', {oldPassword: oldPassword, newPassword: newPassword, confirmationPassword:confirmationPassword})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Mot de passe modifié aves succés")
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})

    },
    getProfilInfo() {
        return axios.get('/api/users/get/profilInfo')
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    changeProfilInfo(profilInfo){
        return axios.post('/api/users/save/profilInfo', profilInfo)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Infos enregistrés aves succés")
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    uploadImage(formData){
        return axios.post("/api/users/logo/upload/", formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Logo modifié avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    uploadLogo(formData,supplierId){
        return axios.post("/api/users/admin/logo/upload/"+supplierId, formData, {headers: {'Content-Type': 'multipart/form-data' }})
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Logo modifié avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },
    deleteImage(){
        return axios.post("/api/users/remove/logo/")
        .then(response => {
            if (response && response.data) { 
                Vue.prototype.$snotify.success("Logo supprimé avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    deleteLogo(supplierId){
        return axios.post("/api/users/admin/remove/logo/"+supplierId)
        .then(response => {
            if (response && response.data) { 
                Vue.prototype.$snotify.success("Logo supprimé avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveContact(contact){
        return axios.post("/api/users/save/contact/",contact)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Contact enregistré avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    removeContact(contact){
        return axios.post("/api/users/remove/contact/",contact)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Contact supprimé avec succès");
                 return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    getUserInfo (id, isCustomer) {
        return axios.get('/api/users/info/',{ params: { id: id,isCustomer:isCustomer } })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findContacts (id) {
        return axios.get('/api/users/contacts/',{ params: { id: id } })
        .then(response => {
            if (response && response.data) return response.data;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    saveUser(user){
        return axios.post("/api/users/save/",user)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Utilisateur enregistré avec succès");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    // removeUser(user){
    //     return axios.post("/api/users/remove/",user)
    //     .then(response => {
    //         if (response && response.data) {
    //             Vue.prototype.$snotify.success("Utilisateur supprimé avec succès");
    //              return response.data;
    //         }
    //     })
    //     .catch(error => {Vue.prototype.$snotify.error(error);})
    // },

    adminUpdatePassword(selectedUserId,newPassword){
        return axios.post('/api/users/admin/password/change/'+selectedUserId,{newPassword : newPassword} )
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Mot de passe modifié aves succés")
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    sendBecomeMember(becomeMember){
        return axios.post('/api/users/become-member',becomeMember)
        .then(response => {
            if (response && response.data) {
                Vue.prototype.$snotify.success("Votre demande d'adhésion a été envoyée à LGP");
                return response.data;
            }
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}